import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "backdrop"]

  toggle() {
    this.sidebarTarget.classList.toggle("open")
    this.backdropTarget.classList.toggle("open")
  }

  close() {
    this.sidebarTarget.classList.remove("open")
    this.backdropTarget.classList.remove("open")
  }
}
